import { render, staticRenderFns } from "./TwBenchmarkTagAssignDialog.vue?vue&type=template&id=8432932e&scoped=true"
import script from "./TwBenchmarkTagAssignDialog.vue?vue&type=script&lang=ts"
export * from "./TwBenchmarkTagAssignDialog.vue?vue&type=script&lang=ts"
import style0 from "./TwBenchmarkTagAssignDialog.vue?vue&type=style&index=0&id=8432932e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8432932e",
  null
  
)

export default component.exports